<script setup>
defineProps({
    delta: { type: Number, default: 0 },
})
</script>

<template>
    <span
        class="inline-flex items-center gap-0.5 text-[11.5px] font-bold px-1.5 py-0.5 rounded-full"
        :class="{
            'bg-[#E0F2E7] dark:bg-green-950 text-[#0F5B3A] dark:text-green-400': delta > 0,
            'bg-[#F4E0DE] dark:bg-red-950 text-[#8A2722] dark:text-red-400': delta < 0,
            'bg-gray-100 dark:bg-neutral-800 text-gray-400 dark:text-neutral-500': delta === 0,
        }"
    >
        <svg v-if="delta > 0" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" style="width:10px;height:10px"><path d="M8 12V4M4 8l4-4 4 4"/></svg>
        <svg v-else-if="delta < 0" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" style="width:10px;height:10px"><path d="M8 4v8M4 8l4 4 4-4"/></svg>
        <span v-if="delta === 0">{{ $t('dashboard.no_change') }}</span>
        <span v-else>{{ Math.abs(delta) }} %</span>
    </span>
</template>
